class ViewSwitch {
    constructor() {
        this.input = document.querySelector('#view-switch');
        this.peopleContainer = document.querySelector('.people');

        if (!this.input || !this.peopleContainer) return;
        this.events();
    }

    events() {
        this.input.addEventListener('change', this.switchView.bind(this));
    }

    // Methods
    switchView() {
        if (this.input.checked) {
            this.peopleContainer.classList.add('people--no-img');
        } else {
            this.peopleContainer.classList.remove('people--no-img');
        }
    }
}

export default new ViewSwitch();
